import { createAction, props } from '@ngrx/store';
import { SearchTarget } from '@cpak/adp-cpak-bff-service-models';

export const updateSearchSort = createAction(
  'Search sorting update',
  props<{ target: SearchTarget; sort: string; sortOrder: string }>()
);

export const resetSearchSort = createAction('Search sorting reset', props<{ target: SearchTarget }>());
